<template>
  <b-modal id="download-csv" title="Descargar detalle" :ok-disabled="loading || !fromDate || !toDate" @ok="handleOk">
    <!-- form with from_date, to_date inputs -->
    <b-form>
      <b-form-group label="Desde">
        <b-form-datepicker
          v-model="$v.fromDate.$model"
          :state="$v.fromDate.$dirty ? !$v.fromDate.$error : null"
        ></b-form-datepicker>
      </b-form-group>
      <b-form-group label="Hasta">
        <b-form-datepicker
          :disabled="!fromDate"
          v-model="$v.toDate.$model"
          :min="$v.fromDate.$model"
          :state="$v.toDate.$dirty ? !$v.toDate.$error : null"
        ></b-form-datepicker>
      </b-form-group>
    </b-form>
  </b-modal>
</template>

<script>
import { required } from "vuelidate/lib/validators";
export default {
  name: "DownloadCsv",
  data() {
    return {
      loading: false,
      fromDate: null,
      toDate: null
    };
  },
  validations() {
    return {
      fromDate: {
        required
      },
      toDate: {
        required
      }
    };
  },
  methods: {
    handleOk(evt) {
      evt.preventDefault();
      this.loading = true;
      this.downloadWithAxios();
      this.loading = false;
      this.$bvModal.hide("download-csv");
    },
    forceFileDownload(response, a) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "detalle_materiales" + this.fromDate + "a" + this.toDate + ".csv"); //or any other extension
      document.body.appendChild(link);
      link.click();
    },

    downloadWithAxios(a, b) {
      this.$axios({
        method: "get",
        url: `reports/api_materiales/?from_date=${this.fromDate}&to_date=${this.toDate}`,
        responseType: "arraybuffer"
      })
        .then((response) => {
          this.forceFileDownload(response, b);
          this.loading = false;
          this.fromDate = null;
          this.toDate = null;
        })
        .catch(() => {
          console.log("error occured");
        });
    }
  }
};
</script>

<style></style>
